<template>
  <div class="flex flex-col min-h-0">
    <!-- Content -->
    <div class="flex-1">
      <h3 class="text-lg font-medium leading-6 text-white">Follow List</h3>
      <p class="mt-2 text-sm text-gray-400">
        You'll see updates when new items are added to this list.
      </p>

      <!-- List preview -->
      <div
        v-if="list"
        class="flex gap-3 items-center p-3 mt-4 rounded-lg bg-white/5">
        <div class="flex-1 min-w-0">
          <p class="text-sm font-medium text-white truncate">
            {{ list.title }}
          </p>
          <p v-if="list.profiles" class="text-xs text-gray-500">
            by @{{ list.profiles.username }}
          </p>
        </div>
      </div>
    </div>

    <!-- Actions - full width at bottom -->
    <div class="flex flex-col gap-2 pt-6 mt-auto">
      <button
        type="button"
        class="py-3 w-full text-sm font-semibold text-white bg-gradient-to-r to-indigo-500 rounded-lg transition-all cursor-pointer from-sky-500 hover:from-sky-400 hover:to-indigo-400"
        @click="followList">
        Follow List
      </button>
      <button
        type="button"
        class="w-full py-3 text-sm font-medium text-gray-400 rounded-lg cursor-pointer hover:text-white hover:bg-white/10 transition-all"
        @click="close">
        Cancel
      </button>
    </div>
  </div>
</template>

<script setup>
import { useStoreLists } from '@/stores/storeLists'

const props = defineProps({
  list: Object
})

const emit = defineEmits(['close'])

const storeLists = useStoreLists()

const close = () => {
  emit('close')
}

// Function to remove the list
async function followList() {
  storeLists
    .followList(props.list.id)
    .then(() => {
      close()
    })
    .catch((error) => {
      // removeError.value = error
      console.log('error', error)
    })
}
</script>
